/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Action_JoinInputs */

const en_footer_action_join = /** @type {(inputs: Footer_Action_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join PauseAI`)
};

/**
* | output |
* | --- |
* | "Join PauseAI" |
*
* @param {Footer_Action_JoinInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_action_join = /** @type {((inputs?: Footer_Action_JoinInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Action_JoinInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_action_join(inputs)
});